import React, { Component } from 'react';
import { Table } from 'antd';
import { getWalletOrders } from '@/api/wallet';

const TRADING_TYPE = {
  CONSUMPTION: '收入',
  WITHDRAW: '提现',
  TRANSFER: '转账'
}

const columns = [{
  title: '订单编号',
  dataIndex: 'tradingId',
  key: 'tradingId',
}, {
  title: '金额（元）',
  dataIndex: 'totalFee',
  key: 'totalFee',
}, {
  title: '类型',
  dataIndex: 'tradingType',
  render: (text) => TRADING_TYPE[text] || '未知',
}, {
  title: '创建时间',
  dataIndex: 'ctime',
  key: 'ctime',
}];

class OrderTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      orderList: [],
      total: 0,
      current: 1,
    };
  }

  componentDidMount() {
    getWalletOrders().then(data => {
      this.setState({
        orderList: data.tradingRecords,
        total: data.total
      })
    })
  }

  handleChange = (pagination) => {
    const offset = (pagination.current - 1) * 10;
    getWalletOrders(offset).then(data => {
      this.setState({
        orderList: data.tradingRecords,
        total: data.total,
        current: pagination.current,
      })
    })
  }

  render() {
    const { orderList, total, current } = this.state;
    return (
      <Table
        columns={columns}
        dataSource={orderList}
        onChange={this.handleChange}
        pagination={
          {
            total,
            pageSize: 10,
            current: current
          }
        }
      />
    );
  }
}
export default OrderTable;